<template>
  <div>
    <div class="news_title">{{ title }}</div>
    <div class="wrapper-news" v-show="loaded">
      <div v-swiper:rss_swiper="swiperOption">
        <div class="swiper-wrapper">
          <a
            class="swiper-slide"
            v-for="news in rssRengaFeed"
            :key="news.pubDate"
            :href="news.link + '?from=bimlib.pro'"
            target="_blank"
          >
            <div class="rss-block">
              <div class="rss-block__date">
                <img alt="" src="/dist/assets/front_white/img/svg/calendar.svg" />
                <span>{{ news.pubDate | dateFilter }}</span>
              </div>
              <div class="rss-block__title">{{ news.title }}</div>
            </div>
          </a>
        </div>
      </div>

      <div class="swiper-pagination"></div>

      <bim-button
        v-show="prev_show"
        id="content-button-prev"
        text-color="#4d4d4d"
        color="white"
        icon-size="18"
        rounded
        icon="icon-arrow-left22"
        class="slider-arrows slider-arrows--prev slider-arrows--ar-models"
      />

      <bim-button
        v-show="next_show"
        id="content-button-next"
        text-color="#4d4d4d"
        color="white"
        icon-size="18"
        rounded
        icon="icon-arrow-right22"
        class="slider-arrows slider-arrows--next slider-arrows--ar-models"
      />
    </div>
  </div>
</template>

<script>
import breakpoint from "@/mixins/breakpoint.js"

import { directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  mixins: [breakpoint],
  directives: {
    swiper: directive,
  },
  data() {
    return {
      title: "",
      rss: null,
      loaded: false,
      prev_show: false,
      next_show: true,
      swiperOption: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        navigation: {
          nextEl: '#content-button-next',
          prevEl: '#content-button-prev',
        },
        on: {
          fromEdge: (function() {
            this.prev_show = true;
            this.next_show = true;
          }).bind(this),

          reachBeginning: (function() {
            this.prev_show = false;
          }).bind(this),

          reachEnd: (function() {
            this.next_show = false;
          }).bind(this),
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true,
        },
        breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 1,
            slidesPerGroup: 1,
          },
          767: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          1000: {
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
          1279: {
            slidesPerView: 3,
            slidesPerGroup: 3,
          }
        }
      },
    }
  },
  watch: {
    'rss_swiper.isBeginning'(val) {
      console.log(val)
    }
  },
  created() {
    axios
      .get("/?m=statics&a=GetRssRenga")
      .then(res => res.data)
      .then(({ status_code, rss }) => {
        if (status_code === 200) {
          return rss
        }
        throw new Error("Something went wrong")
      })
      .then(res => {{
        this.title = res.channel.description
        this.rss = res
        this.loaded = true
      }})
      .catch(error => console.error(error))
  },
  computed: {
    rssRengaFeed() {
      if (this.rss) {
        const item = []
          .concat(this.rss.channel.item)
          .sort(({ pubDate: a }, { pubDate: b }) => new Date(b) - new Date(a))
        if (this.ww <= 576) {
          return item.slice(0, 12)
        }
        else if (this.ww <= 768) {
          return item.slice(0, 24)
        }
        return item
      }
      return []
    }
  },
  filters: {
    dateFilter(val) {
      const date = new Date(val)
      const now = new Date()
      const months = ["января", "февраля", "марта", "апреля", "мая", "июня", "июля", "августа", "сентября", "октября", "ноября", "декабря"]
      if (now - date < 300000) {
        return "Только что"
      }
      else if (!(now.getFullYear() - date.getFullYear())) { // если в текущем году

        if (now.getMonth() - date.getMonth() === 0) { // в текущем месяце

          if (!(now.getDate() - date.getDate())) { // сегодня
            const mins = parseInt((now - date) / 1000 / 60)
            const hour = parseInt(mins / 60)
            if (hour < 1) { // меньше часа
              return `${mins} минут назад`
            }
            else if (hour === 1) { // час назад
              return "Час назад"
            }
            else if ([2, 3, 4, 22, 23].includes(hour)) {
              return `${hour} часа назад`
            }
            else if (hour >= 5 && hour <= 20) {
              return `${hour} часов назад`
            }
            else { // 21 час
              return `${hour} час назад`
            }
          }
          else if (now.getDate() - date.getDate() === 1) { // вчера
            return 'Вчера'
          }
          else {
            return `${date.getDate()} ${months[date.getMonth()]}`
          }
        }
        else {
          return `${date.getDate()} ${months[date.getMonth()]}`
        }
      }
      else {
        return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/settings";
.news_title {
  font-size: 36px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 32px;
  @media screen and (max-width: 576px) {
    font-size: 24px;
  }
}

.wrapper-news {
  position: relative;
  margin: 0 auto 40px;
  max-width: calc(206px * 3 + 20px * 3);
}

.rss-block {
  max-width: 206px;
  margin: auto;
  @media screen and (max-width: 576px) {
    max-width: 70%;
  }
}

.rss-block__title {
  font-size: 14px;
  font-weight: bold;
  line-height: 1.43;
}

.rss-block__date {
  display: flex;
  align-items: center;
  margin-bottom: 7px;

  span {
    margin-left: 4px;
    opacity: 0.5;
    font-size: 12px;
    line-height: 1.83;
    letter-spacing: 0.5px;
  }
}

.swiper-pagination {
  position: relative;
  margin-top: 10px;
  ::v-deep &-bullet {
    width: 5px;
    height: 5px;
    margin-right: 5px;
    @media screen and (max-width: 576px) {
      &:last-child {
        margin-right: 0;
      }
    }
  }
  ::v-deep &-bullet-active {
    background-color: $primary-color;
  }
}

#content-button-next,
#content-button-prev {
  width: 42px;
  height: 42px;
  box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.15);
  border-radius: 50%;
  z-index: 1;
  top: 25px;
  position: absolute;
  @media screen and (max-width: 576px) {
    display: none;
  }
}

#content-button-next {
  right: -40px;
  @media screen and (max-width: 768px) {
    right: 0;
  }
}
#content-button-prev {
  left: -40px;
  @media screen and (max-width: 768px) {
    left: 0;
  }
}
</style>